<template>
  <b-container class="mt-5 pb-5">
    <div v-if="community">
      <b-row>
        <b-col cols="10">
          <h1 class="font-weight-light">
            {{ community.title }}
          </h1>
        </b-col>
        <b-col
          cols="2"
          class="text-right align-self-center"
        >
          <h4 class="mb-0">
            <b-badge class="pink">
              {{ community.type.title }}
            </b-badge>
          </h4>
          <h4 class="mb-0 mt-1">
            <b-badge :variant="badgeStatus[community.status]">
              {{ badgeText[community.status] }}
            </b-badge>
          </h4>
        </b-col>
      </b-row>

      <b-row>
        <b-breadcrumb>
          <b-breadcrumb-item :to="{ name: 'communities' }">
            <b-icon
              icon="house-fill"
              scale="1.25"
              shift-v="1.25"
              aria-hidden="true"
            />
            Communities
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            {{ community.title }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </b-row>

      <b-row class="justify-content-center mt-2">
        <b-col>
          <b-img
            :src="getImage(community)"
            rounded
            fluid-grow
          />
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <p class="lead">
            <vue-simple-markdown :source="community.description" />
          </p>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <div class="status d-block d-sm-none">
            <h5>
              <b-badge :variant="badgeStatus[community.status]">
                {{ badgeText[community.status] }}
              </b-badge>
            </h5>
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="community.events.length !== 0"
        class="mt-4"
      >
        <b-col
          cols="12"
          class="mb-2 mt-3"
        >
          <h2 class="font-weight-light">
            コミュニティのイベント一覧
          </h2>
        </b-col>

        <EventCard
          v-for="event in community.events"
          :key="event.slug"
          :event="event"
          col-size="4"
        />
      </b-row>
      <!--<b-row>
            <b-col>
              <h3 class="mt-3">
                Tags
              </h3>
              <div>
                <b-badge
                  v-for="item in community.tags"
                  :key="item.id"
                  variant="info"
                >
                  {{ item.title }}
                </b-badge>
              </div>
            </b-col>
          </b-row>-->
      <b-row class="justify-content-center mt-5">
        <div class="action-buttons">
          <b-col
            cols="12"
            sm="6"
          >
            <b-form-group>
              <b-button
                :to="{name: 'community-edit', params: {id: community.id}}"
                block
                variant="primary"
                size="lg"
              >
                コミュニティを編集
              </b-button>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            sm="6"
          >
            <b-form-group>
              <b-button
                block
                :variant="community.isActive? 'danger' :'success'"
                size="lg"
                @click="updateStatus(!community.isActive)"
              >
                {{ community.isActive ?'コミュニティを非公開する' :'コミュニティを公開する' }}
              </b-button>
            </b-form-group>
          </b-col>
        </div>
      </b-row>
    </div>
    <Loader v-if="communityStatus === 'loading'" />
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {COMMUNITY_DETAIL_REQUEST, COMMUNITY_EDIT} from "@/store/constant";
import {getImage} from "@/helpers";
import community from "@/components/mixins/community";
import EventCard from "@/modules/EventCard";
import Loader from "@/components/Loader";

export default {
  name: 'CommunityDetail',
  components: {Loader, EventCard},
  mixins: [community],
  computed: {
    ...mapGetters(['community', 'communityStatus'])
  },
  mounted() {
    this.getCommunity();
  },
  methods: {
    getCommunity() {
      this.$store.dispatch(COMMUNITY_DETAIL_REQUEST, this.$route.params.id);
    },
    getImage,
    updateStatus(status) {
      this.$store.dispatch(COMMUNITY_EDIT, {isActive: status, id: this.$route.params.id})
        .then(() => {
          this.$router.push({ name: 'communities' });
        })
    },
  }
}
</script>

<style lang="less" scoped>
.status {
  position: absolute;
  top: 15px;
  right: 20px;
  display: none;
}

.action-buttons {
  position: fixed;
  bottom: 0;
  width: 1110px;
  display: flex;
  z-index: 2;
}

</style>
